/**
 * Maps currency codes to their primary country codes
 * Used for daily allowance calculations in refund reports
 */
export const CURRENCY_TO_COUNTRY: Record<string, string> = {
  'USD': 'US',
  'EUR': 'FR', // Default to France for EUR, though it's used in many countries
  'GBP': 'GB',
  'JPY': 'JP',
  'CHF': 'CH',
  'CAD': 'CA',
  'AUD': 'AU',
  'CNY': 'CN',
  'INR': 'IN',
  'KRW': 'KR',
  'BRL': 'BR',
  'MXN': 'MX',
  'RUB': 'RU',
  'ZAR': 'ZA',
  'SEK': 'SE',
  'NOK': 'NO',
  'DKK': 'DK',
  'PLN': 'PL',
  'THB': 'TH',
  'IDR': 'ID',
  'HUF': 'HU',
  'CZK': 'CZ',
  'ILS': 'IL',
  'CLP': 'CL',
  'PHP': 'PH',
  'AED': 'AE',
  'SAR': 'SA',
  'MYR': 'MY',
  'TRY': 'TR',
  'NZD': 'NZ',
  'SGD': 'SG',
  'HKD': 'HK',
  'ARS': 'AR',
  'COP': 'CO',
  'PEN': 'PE',
  'VND': 'VN',
  'EGP': 'EG',
  'NGN': 'NG',
  'PKR': 'PK',
  'BDT': 'BD',
  'UAH': 'UA',
  'KES': 'KE',
};

export const COUNTRY_TO_NAME: Record<string, string> = {
  'US': 'United States',
  'FR': 'France',
  'GB': 'United Kingdom',
  'JP': 'Japan',
  'CH': 'Switzerland',
  'CA': 'Canada',
  'AU': 'Australia',
  'CN': 'China',
  'IN': 'India',
  'KR': 'South Korea',
  'BR': 'Brazil',
  'MX': 'Mexico',
  'RU': 'Russia',
  'ZA': 'South Africa',
  'SE': 'Sweden',
  'NO': 'Norway',
  'DK': 'Denmark',
  'PL': 'Poland',
  'TH': 'Thailand',
  'ID': 'Indonesia',
  'HU': 'Hungary',
  'CZ': 'Czech Republic',
  'IL': 'Israel',
  'CL': 'Chile',
  'PH': 'Philippines',
  'AE': 'United Arab Emirates',
  'SA': 'Saudi Arabia',
  'MY': 'Malaysia',
  'TR': 'Turkey',
  'NZ': 'New Zealand',
  'SG': 'Singapore',
  'HK': 'Hong Kong',
  'AR': 'Argentina',
  'CO': 'Colombia',
  'PE': 'Peru',
  'VN': 'Vietnam',
  'EG': 'Egypt',
  'NG': 'Nigeria',
  'PK': 'Pakistan',
  'BD': 'Bangladesh',
  'UA': 'Ukraine',
  'KE': 'Kenya',
};

/**
 * Get country code from currency code
 */
export const getCountryFromCurrency = (currency: string): string => {
  return CURRENCY_TO_COUNTRY[currency.toUpperCase()] || 'DEFAULT';
};

/**
 * Get country name from country code
 */
export const getCountryName = (countryCode: string): string => {
  return COUNTRY_TO_NAME[countryCode.toUpperCase()] || 'Other';
};

/**
 * Get country name from currency code
 */
export const getCountryNameFromCurrency = (currency: string): string => {
  const countryCode = getCountryFromCurrency(currency);
  return getCountryName(countryCode);
};
